/**
 * @file 记录当前用户最近访问的页面（sessionStorage）
 */

const SESSION_RECENT_PAGES_KEY = 'xdesign_recent_visited_pages';
const MAX_RECENT_PAGES = 10;

function readPages(): string[] {
    try {
        const raw = window.sessionStorage.getItem(SESSION_RECENT_PAGES_KEY);
        if (!raw) {
            return [];
        }
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string') : [];
    } catch {
        return [];
    }
}

function writePages(pages: string[]): void {
    try {
        window.sessionStorage.setItem(SESSION_RECENT_PAGES_KEY, JSON.stringify(pages));
    } catch {
        // sessionStorage 不可用或配额不足时静默失败
    }
}

/** 写入当前页（默认 location.href），置顶，去重，最多 10 条 */
export function pushSessionRecentPage(url?: string): void {
    const pageUrl = url ?? window.location.href;
    if (!pageUrl) {
        return;
    }
    const next = [pageUrl, ...readPages().filter((item) => item !== pageUrl)].slice(0, MAX_RECENT_PAGES);
    writePages(next);
}

/** 读取最近访问列表（最新在前） */
export function getSessionRecentPages(): string {
    return readPages().join(',') || '';
}
